import loadable from '@loadable/component';
import hydrateLocalComponents from '@skyscanner-internal/local-components-client/hydrate';

import components from './components';
import withEmotionCache from './withEmotionCache';

// Gives BPK 2.0 / Chakra components (e.g. BpkProvider) an outer Emotion
// cache boundary to hydrate against. See withEmotionCache.tsx. CLOV-1993.
const withCache = (modulePromise) =>
  modulePromise.then((mod) => ({
    default: withEmotionCache(mod.default),
  }));

export default function hydrate() {
  hydrateLocalComponents({
    ...components,
    FeatureContainer: loadable(() =>
      withCache(import('./components/FeatureContainer')),
    ),
  });
}
